import { OtpRequestSchema, OtpVerifySchema } from '@parky/shared';
import { simpleApiClient } from '../../utils/simpleApiClient';

// Utiliser le SimpleApiClient pour éviter les problèmes CORS
export const apiClient = simpleApiClient;

// Set token from localStorage on initialization
const token = localStorage.getItem('token');
const refreshToken = localStorage.getItem('refreshToken');
if (token) {
  apiClient.setTokens(token, refreshToken || undefined);
}

export const authService = {
  async requestOtp(phone: string) {
    console.log('📱 Requesting OTP for phone:', phone);
    // console.log('🌐 API Base URL:', API_BASE_URL);
    // console.log('🔗 Full URL:', `${API_BASE_URL}/auth/otp/request`);
    
    const data = OtpRequestSchema.parse({ phone });
    console.log('📦 Request data:', data);
    
    try {
      const response = await apiClient.post('/auth/otp/request', data);
      console.log('✅ OTP request successful:', response);
      return response;
    } catch (error) {
      console.error('❌ OTP request failed:', error);
      throw error;
    }
  },

  async verifyOtp(phone: string, code: string) {
    console.log('🔐 Verifying OTP:', { phone, code, codeLength: code.length, codeType: typeof code });
    
    const data = OtpVerifySchema.parse({ phone, code });
    console.log('📦 Parsed data:', data);
    
    try {
      const response = await apiClient.post('/auth/otp/verify', data);
      console.log('✅ OTP verification successful:', response);
      return response;
    } catch (error) {
      console.error('❌ OTP verification failed:', error);
      throw error;
    }
  },

  async getProfile() {
    return apiClient.get('/users/me');
  },

  async refreshToken() {
    const refreshToken = localStorage.getItem('refreshToken');
    if (!refreshToken) throw new Error('No refresh token');
    
    const response = await apiClient.post('/auth/refresh', { refreshToken });
    return (response as any).data;
  },
};

// Fonction pour mettre à jour les tokens dans l'ApiClient
export const updateApiClientTokens = (accessToken: string, refreshToken: string) => {
  apiClient.setTokens(accessToken, refreshToken);
};

// Fonction pour nettoyer les tokens dans l'ApiClient
export const clearApiClientTokens = () => {
  apiClient.setTokens('', '');
};
